import React, {useEffect, useState} from 'react';
import {useIntl} from 'react-intl';
import {Banner, BANNER_TYPE, View, ViewProperties} from '@lookiero/aurora';

import {ReferralApplication} from '@raf/core/application';
import {ReferralForShare} from '@raf/core/domain/ReferralForShare';
import {useReferralLink} from '@raf/ui/hooks/useReferralLink';
import {ShareModal} from '@views/Referrals/_components/ShareModal/ShareModal';
import {Section} from '@views/Referrals';

import {TEXT, ID} from './ReferralsShareBanner.definition';

import {useRafImagePath} from '../hooks/useRafImagePaths';

export interface ReferralShareBannerProps extends ViewProperties {
  bannerType?: BANNER_TYPE;
  scaledBanner?: boolean;
  section: Section;
}

export const ReferralsShareBanner: React.FC<ReferralShareBannerProps> = ({
  section,
  bannerType = BANNER_TYPE.SQUARED,
  scaledBanner = true,
  ...rest
}) => {
  const {formatMessage} = useIntl();
  const [referral, setReferral] = useState<ReferralForShare>({
    referralCredit: 0,
    referredCredit: 0,
    referralCode: '',
  });
  const [shareModalVisible, setShareModalVisible] = useState<boolean>(false);
  const {shareReferral} = useReferralLink({
    referralCode: referral.referralCode,
    referredCredit: referral.referredCredit,
  });
  const bannerShareImage = useRafImagePath('banner-share');

  useEffect(() => {
    ReferralApplication.getReferralForShare().then(data => {
      if (data) setReferral(data);
    });
  }, []);

  const copyLink = (): void => void shareReferral('clipboard', section);

  return (
    <>
      <View {...rest}>
        <Banner
          title={formatMessage(TEXT.TITLE, {referralCredit: referral.referralCredit})}
          description={formatMessage(TEXT.SUBTITLE, {
            referralCredit: referral.referralCredit,
            referredCredit: referral.referredCredit,
          })}
          image={bannerShareImage}
          primaryButton={{text: formatMessage(TEXT.COPY_CTA), onPress: copyLink, icon: 'copy'}}
          secondaryButton={{
            text: formatMessage(TEXT.SHARE_CTA),
            onPress: () => setShareModalVisible(true),
            icon: 'share',
          }}
          type={bannerType}
          scaled={scaledBanner}
          nativeID={ID.BANNER}
        />
      </View>
      <ShareModal
        isVisible={shareModalVisible}
        onClose={() => setShareModalVisible(false)}
        referralCode={referral.referralCode}
        referredCredit={referral.referredCredit}
        section={section}
      />
    </>
  );
};
